import React, { useState } from "react";
import styled from "styled-components";
import { Link, withPrefix } from "gatsby";
import IconLookingGlass from "../IconLookingGlass";
import cleanCompanyName from "../../utilities/cleanCompanyName";
import AutosuggestSearch from "../controls/AutosuggestSearch";


const DiscussionHeader = ({ searchIndex, title, description, getEntityHash, getEntityTitle, entity, entityTypeFilter }) => {

  const [searchVisible, setSearchVisible] = useState(false);

  function getClassName() {
    let className = "";
    className = "is-entity-view";
    if ( searchVisible ) {
      className += " is-search-visible";
    }
    return className;
  }

  return (
    <StyledSupplyChainHeader className={getClassName()}>
      <nav>
        <h1 className="title">
          <Link to="/discussion/" title="Discussion Overview">{title}</Link>
        </h1>
        <ol className="breadcrumbs">
          <li>
            {entity ? (
              <Link to={"/discussion/stakeholders"} title="View all stakeholders">Stakeholders</Link>
            ) : (
              <span>Stakeholders</span>
            )}
          </li>
          {entity && (
            <li><span>{cleanCompanyName(entity.name)}</span></li>
          )}
        </ol>
      </nav>
      <div className="search-toggle">
        <button type="button" onClick={() => setSearchVisible( !searchVisible )}><IconLookingGlass /></button>
      </div>
      <div className="search-form">
        <AutosuggestSearch 
          searchIndex={searchIndex} 
          getEntityHash={getEntityHash}
          getEntityTitle={getEntityTitle}
          placeholderText="Search stakeholders..."
        />
      </div>
    </StyledSupplyChainHeader>
  )
};

export default DiscussionHeader;

const StyledSupplyChainHeader = styled.div`
  &::before {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    left: 50%;
    width: 100vw;
    margin-left: -50vw;
    display: block;
    z-index: -1;
    background-color: var(--color-black);
  }
  
  position: sticky;
  top: 0;
  z-index: 99;
  display: grid;
  grid-template: auto / 1fr;
  align-items: center;
  padding: calc(var(--navbar-height) + 0.25em) 0 1em;
  margin-top: calc(var(--navbar-height) * -1);
  gap: 0.75em;
  border-bottom: 1px solid;


  nav {
    display: flex;
    align-items: baseline;
  }
  .title {
    font-family: var(--font-serif);
    font-size: 1.375em;
    font-weight: normal;
    text-transform: none;
    line-height: 1;
    margin: 0;
    @media ( min-width: 48em ) {
      font-size: 1.75em;
    }
    .can-hover & a:hover,
    & a:active {
      text-decoration-line: underline;
      text-decoration-thickness: 0.75px;
      text-underline-offset: 0.1em;
      text-decoration-color: rgba(255,255,255,0.5);
    }
  }

  .breadcrumbs {
      display: flex;
      align-items: baseline;
      gap: 0.5em;
      margin: 0 0 0 0.5em;
      padding: 0;
      list-style: none;
      li {
        &:first-of-type {
          text-transform: capitalize;
        }
        @media ( max-width: 48em ) {
          &:last-of-type:not(:first-of-type) {
            display: none;
          }
        }
        &::before {
          content: "/";
          display: inline-block;
          margin-right: 0.5em;
        }
        a,
        span {
          font-size: 0.875em;
          font-weight: 500;
          line-height: 1;
          @media ( min-width: 48em ) {
            font-size: 1em;
          }
        }
        .can-hover & a:hover,
        a:active {
          text-decoration-line: underline;
          text-decoration-thickness: 0.75px;
          text-underline-offset: 0.1em;
          text-decoration-color: rgba(255,255,255,0.5);
        }
    }
  }

  @media ( max-width: 60em ) {
    grid-template: auto / 1fr auto;
    padding: calc(var(--navbar-height) + 0.5em) 0 0.625em;
    gap: 0.5em 0.75em;
    .title {
      display: block;
      font-size: 1.5em;
      white-space: nowrap;
    }
    .search-toggle {

      transform: translate3d(0,-0.25em,0);
    }
    &.is-search-visible .search-toggle button {
      position: relative;
      svg {
        opacity: 0;
      }
      &::before,
      &::after {
        content: "";
        position: absolute;
        top: 50%;
        width: 1.25em;
        left: -0.125em;
        height: 2px;
        border-radius: 0.125em;
        background-color: currentColor;
        transition: opacity 0.2s ease;
      }
      &::before {
        transform: rotate(45deg);
      }
      &::after {
        transform: rotate(-45deg);
      }
    }
    .search-form {
      /*
      position: absolute;
      top: calc(100% - 0.375em);
      right: 0;
      left: 0;
      padding: 0 0 0.5em;
      background-color: var(--color-black);
      border-bottom: 1px solid;
      */
      grid-column: 1 / span 2;
      display: none;
    }
    &.is-search-visible {
      .search-form {
        display: block;
      }
    }
  }

  @media ( min-width: 60em ) {
    grid-template: 1fr / 1fr 20em;
    padding: calc(var(--navbar-height) + 1.5em) 0 1em;
    .search-toggle {
      display: none;
    }
  }


`;
